<template>
  <div class="animated fadeIn timelog-hub">
    <div class="card shadow-sm border-0 mb-3">
      <div class="card-header bg-facebook text-white py-3">
        <h5 class="mb-0 font-weight-bold"><font-awesome-icon icon="clock" /> Time Log</h5>
        <small class="text-white-50">Attendance processing for office employees and site workers.</small>
      </div>
    </div>

    <b-row>
      <b-col v-for="group in visibleGroups" :key="group.name" lg="6" class="mb-3">
        <div class="card shadow-sm border-0 h-100">
          <div class="card-header text-white py-2 d-flex align-items-center justify-content-between" :class="group.color">
            <h6 class="mb-0"><font-awesome-icon :icon="group.icon" /> {{ group.name }}</h6>
            <small class="text-white-50">{{ group.subtitle }}</small>
          </div>
          <div class="list-group list-group-flush">
            <component
              v-for="item in group.items"
              :key="item.to"
              :is="item.external ? 'a' : 'router-link'"
              :to="item.external ? undefined : item.to"
              :href="item.external ? resolve(item.to) : undefined"
              :target="item.external ? '_blank' : undefined"
              rel="noopener noreferrer"
              class="list-group-item list-group-item-action d-flex align-items-center py-3"
            >
              <div class="hub-icon rounded d-flex align-items-center justify-content-center mr-3" :class="group.color">
                <font-awesome-icon :icon="item.icon" />
              </div>
              <div class="flex-grow-1">
                <div class="font-weight-bold text-dark">
                  {{ item.name }}
                  <b-badge v-if="item.external" variant="light" class="ml-1 border">opens in new tab</b-badge>
                </div>
                <small class="text-muted">{{ item.description }}</small>
              </div>
              <font-awesome-icon icon="chevron-left" class="text-muted flip-x" />
            </component>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  export default {
    name: 'TimelogHub',
    data() {
      return {
        groups: [
          {
            name: 'Office Time Log',
            subtitle: 'office employees',
            icon: 'user',
            color: 'bg-dark',
            roles: [1, 2, 3],
            items: [
              { name: 'Attendance', to: '/office-timelog-attendance', icon: 'search', description: 'Generate, review and process the kiosk punches into a batch.', roles: [1, 2, 3] },
              { name: 'For Approval', to: '/office-timelog-for-approval', icon: 'thumbs-up', description: 'Approve or return processed batches.', roles: [1, 2] },
              { name: 'Approved', to: '/office-timelog-approved', icon: 'check-circle', description: 'History of approved batches and their payroll status.', roles: [1, 2] },
              { name: 'Kiosk Devices', to: '/maintenance/office-kiosk', icon: 'qrcode', description: 'Generate activation codes and manage the kiosk machines.', roles: [1, 2] },
              { name: 'Scheduled OT Permission', to: '/maintenance/ot-schedules', icon: 'sign-out-alt', description: 'Allow overtime on the kiosk for a date, time window and purpose.', roles: [1, 2, 3] },
              { name: 'Open Kiosk', to: '/office-timelog', icon: 'clock', description: 'The scanning screen for an activated machine (no login).', external: true, roles: [1, 2] },
            ]
          },
          {
            name: 'Site Time Log',
            subtitle: 'site workers',
            icon: 'road',
            color: 'custom-background-blue',
            items: [
              { name: 'Attendance', to: '/site-timelog-attendance', icon: 'search', description: 'Generate and process site punches per project.' },
              { name: 'For Approval', to: '/site-timelog-for-approval', icon: 'thumbs-up', description: 'Approve processed site batches.' },
            ]
          },
        ]
      }
    },
    computed: {
      roleId() {
        const user = this.$store.getters.userDetails;
        return user ? Number(user.role_id) : null;
      },
      visibleGroups() {
        const allowed = (entry) => !Array.isArray(entry.roles) || entry.roles.indexOf(this.roleId) !== -1;
        return this.groups
          .filter(allowed)
          .map(group => Object.assign({}, group, { items: group.items.filter(allowed) }))
          .filter(group => group.items.length > 0);
      }
    },
    methods: {
      resolve(path) {
        return this.$router.resolve({ path }).href;
      }
    }
  }
</script>

<style scoped>
  .hub-icon {
    width: 38px;
    height: 38px;
    flex: 0 0 38px;
    color: #fff;
  }
  .flip-x {
    transform: scaleX(-1);
  }
</style>
